import { api } from "./api";
import {
  AmbassadorContext,
  AmbassadorDashboard,
  AmbassadorPerson,
  AmbassadorProfile,
  AmbassadorResources,
  AmbassadorStaff,
  AmbassadorHistoryKind,
  AmbassadorApplication,
} from "../types/ambassadors";
const base = "/ambassadors";
export const ambassadors = {
  context: async () =>
    (await api.get<AmbassadorContext>(`${base}/context`)).data,
  dashboard: async () =>
    (await api.get<AmbassadorDashboard>(`${base}/dashboard`)).data,
  supportDay: (items: string[], note: string) =>
    api.post(`${base}/support-day`, { items, note }),
  staff: async () => (await api.get<AmbassadorStaff[]>(`${base}/staff`)).data,
  directory: async (search: string) =>
    (
      await api.get<(AmbassadorPerson & { phone?: string })[]>(
        `${base}/directory`,
        { params: { search } },
      )
    ).data,
  setStaff: (id: string, roles: string[]) =>
    api.patch(`${base}/staff/${id}`, { roles }),
  list: async (params: Record<string, unknown>) =>
    (
      await api.get<{ items: AmbassadorProfile[]; total: number }>(
        `${base}/profiles`,
        { params },
      )
    ).data,
  applications: async (params: Record<string, unknown>) =>
    (
      await api.get<{ items: AmbassadorApplication[]; total: number }>(
        `${base}/applications`,
        { params },
      )
    ).data,
  reviewApplication: async (
    id: string,
    data: {
      decision: "APPROVED" | "REJECTED";
      note?: string;
      supportId?: string;
    },
  ) =>
    (
      await api.patch<AmbassadorApplication>(
        `${base}/applications/${id}/review`,
        data,
      )
    ).data,
  detail: async (id: string) =>
    (await api.get<AmbassadorProfile>(`${base}/profiles/${id}`)).data,
  history: async (id: string, kind: AmbassadorHistoryKind, skip: number) =>
    (
      await api.get(`${base}/profiles/${id}/history`, {
        params: { kind, skip, take: 30 },
      })
    ).data,
  weeklyReview: (id: string, data: unknown) =>
    api.post(`${base}/profiles/${id}/weekly-review`, data),
  starterKit: () => api.post(`${base}/starter-kit`),
  create: (data: unknown) => api.post(`${base}/profiles`, data),
  update: (id: string, data: unknown) =>
    api.patch(`${base}/profiles/${id}`, data),
  checklist: (id: string, key: string, completed: boolean) =>
    api.patch(`${base}/profiles/${id}/checklist/${key}`, { completed }),
  consent: (id: string, accepted: boolean) =>
    api.post(`${base}/profiles/${id}/consent`, { accepted }),
  status: (id: string, status: string, note: string) =>
    api.post(`${base}/profiles/${id}/status`, { status, note }),
  note: (id: string, kind: string, note: string) =>
    api.post(`${base}/profiles/${id}/events`, { kind, note }),
  resources: async () =>
    (await api.get<AmbassadorResources>(`${base}/resources`)).data,
  material: (data: unknown, id?: string) =>
    id
      ? api.patch(`${base}/materials/${id}`, data)
      : api.post(`${base}/materials`, data),
  mission: (data: unknown, id?: string) =>
    id
      ? api.patch(`${base}/missions/${id}`, data)
      : api.post(`${base}/missions`, data),
  review: (id: string, data: unknown) =>
    api.patch(`${base}/reports/${id}/review`, data),
  reply: (id: string, data: unknown) =>
    api.post(`${base}/tickets/${id}/replies`, data),
  export: async (params: Record<string, unknown>) => {
    const response = await api.get(`${base}/profiles/export`, {
      params,
      responseType: "blob",
    });
    const url = URL.createObjectURL(response.data);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "ambassadors.xlsx";
    anchor.click();
    URL.revokeObjectURL(url);
  },
};
